import { useState } from "react";
import Menus from "./menu.json";
import MenuItem from "./menuitem";
import { Layout } from "antd";
import ActionModal from "../component/actionModal";
import { RiLogoutCircleLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/userslice";
import Logo from "../assets/image/logo.png";
import api from "../config/axiosInstance";
const { Sider } = Layout;

function Siders() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoutModal, setLogoutModal] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const User = useSelector((state: any) => state.User.user);

  const logouts = async () => {
    setLogoutLoading(true);
    try {
      await api.post("auth/logout");
    } catch (e) {}
    dispatch(logout({}));
    navigate("/");
  };

  return (
    <Sider
      width={"100%"}
      style={{
        background: "#ffffff",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        borderRight: "1px solid #e1e5e9",
        boxShadow: "2px 0 8px rgba(0, 0, 0, 0.1)",
      }}
      trigger={null}
      collapsible
    >
      <div className="Sider-logoBox" onClick={() => navigate("/Auth")}>
        <img src={Logo} className="Sider-logo" />
      </div>
      {Menus.map((item: any, index: number) => {
        // Robustly parse user_access: handle pipe-separated string OR JSON array string
        let accessList: string[] = [];
        if (User?.user_access) {
          const ua = String(User.user_access).trim();
          if (ua.startsWith('[') && ua.endsWith(']')) {
            try {
              // Legacy JSON string format
              const parsed = JSON.parse(ua);
              if (Array.isArray(parsed)) accessList = parsed.map(String);
            } catch (e) {
              console.error("Failed to parse user_access JSON", e);
            }
          } else {
            // Pipe-separated format (standard)
            accessList = ua.split('|');
          }
        }

        return accessList.includes(String(item?.module_id)) ? (
          <MenuItem
            key={index}
            icon={item.icon}
            title={item.title}
            path={item.navigate}
            logout={() => setLogoutModal(true)}
          />
        ) : null;
      })}

      {logoutModal ? (
        <ActionModal
          visible={logoutModal}
          icon={<RiLogoutCircleLine size={50} color="#f5425d" />}
          text1={"Are you sure you want to logout?"}
          text2={"Your current session will be ended on this device."}
          cancelText="Cancel"
          okText="Logout"
          onClose={() => setLogoutModal(!logoutModal)}
          onOk={logouts}
          loading={logoutLoading}
        />
      ) : null}
    </Sider>
  );
}

export default Siders;
